import { render, staticRenderFns } from "./backgroundSlider.vue?vue&type=template&id=493a6d34&scoped=true"
import script from "./backgroundSlider.vue?vue&type=script&lang=js"
export * from "./backgroundSlider.vue?vue&type=script&lang=js"
import style0 from "./backgroundSlider.vue?vue&type=style&index=0&id=493a6d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a6d34",
  null
  
)

export default component.exports